// src/pages/Leave.jsx
import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAppContext } from '../context/AppContext';

// Employee Components
import LeaveApply from '../components/Leave/LeaveApply';
import LeaveBalance from '../components/Leave/LeaveBalance';
import LeaveHistory from '../components/Leave/LeaveHistory';
import LeaveDetail from '../components/Leave/LeaveDetail';
import LeaveEdit from '../components/Leave/LeaveEdit';

// HR Components
import HrDashboard from '../components/Leave/HrDashboard';
import PendingRequests from '../components/Leave/PendingRequests';

const LeavePage = () => {
  const auth = useAuth();
  const { leave, isLoading: appLoading, dataLoaded } = useAppContext();
  const location = useLocation();

  // ✅ If auth is loading, show spinner
  if (auth.loading) {
    return (
      <div className="flex items-center justify-center min-h-[300px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // ✅ If not authenticated, redirect
  if (!auth.isAuthenticated || !auth.user) {
    return <Navigate to="/login" replace />;
  }

  // ✅ If app is still loading, show spinner
  if (appLoading || !dataLoaded) {
    return (
      <div className="flex items-center justify-center min-h-[300px]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  const { user, isHR } = auth;

  // ✅ If HR and at root leave path, show HR Dashboard
  if (isHR && location.pathname === '/leave') {
    return (
      <div className="p-4 md:p-6">
        <HrDashboard />
      </div>
    );
  }

  // If user is employee and trying to access HR routes, redirect
  if (!isHR && location.pathname.startsWith('/leave/admin')) {
    return <Navigate to="/leave" replace />;
  }

  return (
    <div className="p-4 md:p-6">
      <Routes>
        <Route index element={<LeaveHistory />} />
        <Route path="apply" element={<LeaveApply />} />
        <Route path="balance" element={<LeaveBalance />} />
        <Route path="history" element={<LeaveHistory />} />
        <Route path=":id" element={<LeaveDetail />} />
        <Route path="edit/:id" element={<LeaveEdit />} />
        <Route path="admin/dashboard" element={<HrDashboard />} />
        <Route path="admin/pending" element={<PendingRequests />} />
        <Route path="*" element={<Navigate to="/leave" replace />} />
      </Routes>
    </div>
  );
};

export default LeavePage;